import styles from './ProfileBadge.module.css';

/**
 * The mark beside a name that says "a signed-in account sits here", as
 * opposed to a guest phone. A rosette with a tick, always in the house gold
 * so every player's badge reads the same. It sizes with the text it follows,
 * so the TV plate, a phone header and an owner's row all share it.
 */
export function ProfileBadge({ className }: { className?: string }) {
  return (
    <svg
      className={className ? `${styles.badge} ${className}` : styles.badge}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Signed-in profile"
      data-profile-badge=""
    >
      <title>Signed-in profile</title>
      <path
        className={styles.seal}
        d="M12.0 1.0 L14.4 3.1 L17.5 2.5 L18.5 5.5 L21.5 6.5 L20.9 9.6 L23.0 12.0 L20.9 14.4 L21.5 17.5 L18.5 18.5 L17.5 21.5 L14.4 20.9 L12.0 23.0 L9.6 20.9 L6.5 21.5 L5.5 18.5 L2.5 17.5 L3.1 14.4 L1.0 12.0 L3.1 9.6 L2.5 6.5 L5.5 5.5 L6.5 2.5 L9.6 3.1Z"
      />
      <path className={styles.tick} d="M7.6 12.4l3 3 5.8-6.2" />
    </svg>
  );
}
